"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _validate = _interopRequireDefault(require("../validate"));

function onDelete(leftSelector, rightSelector, filter) {
  var safeLeftSelector = leftSelector || function (action) {
    return action.payload;
  };

  var safeRightSelector = rightSelector || function (item) {
    return item.id;
  };

  var safeFilter = filter || function (item, action) {
    return safeLeftSelector(action, item) !== safeRightSelector(item, action);
  };

  return (0, _validate["default"])({
    name: 'onDelete',
    realTarget: function realTarget(action) {
      return action.target;
    },
    "do": function _do(action, state) {
      return state["".concat(action.target)].filter(function (item) {
        return safeFilter(item, action);
      });
    }
  });
}

var _default = onDelete;
exports["default"] = _default;